<template>
    <PlanbordGridContainer v-if="roster" :informationColumns="informationColumns" :dayColumns="dayColumns" :hourBalanceColumns="hourBalanceColumns" :compact="compact">
        <!-- Include preparedness -->
        <WorkloadRequirementsHead :roster="roster" label="Functie" />
        <WorkloadRequirementsBody
            :roster="roster"
            :organisationDeploymentStates="organisationDeploymentStates"
            :organisationDeploymentTypes="organisationDeploymentTypes"
            :resourceFunctionNames="resourceFunctionNames"
        />
    </PlanbordGridContainer>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import WorkloadRequirementsBody from '@/components/Planbord/WorkloadRequirements/WorkloadRequirementsBody.vue';
    import WorkloadRequirementsHead from '@/components/Planbord/WorkloadRequirements/WorkloadRequirementsHead.vue';
    import {RosterData, PermissionsForRoster} from '@/types/types';
    import {OrganisationDeploymentState, DeploymentType} from '@cquential/api';
    import PlanbordGridContainer from '@/components/Planbord/PlanbordGridContainer.vue';

    @Component({
        components: {
            WorkloadRequirementsBody,
            WorkloadRequirementsHead,
            PlanbordGridContainer,
        },
    })
    export default class WorkloadRequirementsTable extends Vue {
        @Prop({required: true}) public roster!: RosterData;
        @Prop({required: true}) public organisationDeploymentStates!: Record<number, OrganisationDeploymentState>;
        @Prop({required: true}) public organisationDeploymentTypes!: Record<number, DeploymentType>;
        @Prop({required: true}) public permissions!: PermissionsForRoster;
        @Prop({required: true}) public resourceFunctionNames!: Record<number, string>;
        @Prop({type: Number, required: true}) public informationColumns!: number;
        @Prop({type: Number, required: true}) public dayColumns!: number;
        @Prop({type: Number, required: true}) public hourBalanceColumns!: number;
        @Prop({type: Boolean}) public compact!: boolean;
    }
</script>
